package dev.wyns.ventrova.ui.web

import kotlinx.browser.window
import org.w3c.dom.url.URLSearchParams

/** Which platform design the web app shows. */
enum class WebLayout { Desktop, Android, Ios }

/**
 * Picks the design from the user agent: the Android design in Android browsers, the iOS design on
 * iPhone and iPad (iPadOS reports itself as a touch-enabled Mac), the desktop design elsewhere.
 * `?layout=android|ios|desktop` overrides the detection, e.g. for testing.
 */
fun detectWebLayout(): WebLayout {
    val override = URLSearchParams(window.location.search).get("layout")
    WebLayout.entries.firstOrNull { it.name.equals(override, ignoreCase = true) }?.let { return it }

    val userAgent = window.navigator.userAgent
    val touchPoints = window.navigator.asDynamic().maxTouchPoints as? Int ?: 0
    return when {
        "Android" in userAgent -> WebLayout.Android
        Regex("iPhone|iPad|iPod").containsMatchIn(userAgent) -> WebLayout.Ios
        "Macintosh" in userAgent && touchPoints > 1 -> WebLayout.Ios
        else -> WebLayout.Desktop
    }
}
